module.exports = __webpack_public_path__ + "static/media/backgroundAlps.aefe5c5f.m4a";